import './list-booking-entries.scss';

import { arrayOf, bool, func, number, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import CurrencyFormat from '../../../generic/CurrencyFormat';
import { bookingEntryShape } from '../../../prop-types';
import ApplyBudgetDiscountButton from './ApplyBudgetDiscountButton';
import BookingEntryLine from './BookingEntryLine';

function BookingEntriesGroup({
  title,
  entries,
  budget,
  showSelectBox,
  onIsSelected,
  onToggleSelectionMultiple,
  isEditing,
  ...rest
}) {
  const areAllEntriesSelected = entries.every(entry => onIsSelected(entry.id));
  return (
    <>
      <div className="c-balance-line c-invoice-line c-invoice-line__booking-entry-group">
        <Row>
          <Col sm={7} className="font-weight-semi-bold">
            {showSelectBox && (
              <input
                type="checkbox"
                checked={areAllEntriesSelected}
                disabled={!isEditing}
                className="mr-2"
                onChange={() => {
                  onToggleSelectionMultiple(
                    entries.map(entry => `select-${entry.id}`),
                    !areAllEntriesSelected,
                  );
                }}
              />
            )}
            {title}
          </Col>
          <Col sm={2} className="px-0">
            {budget && (
              <span className="text-muted">
                <CurrencyFormat value={budget} text />
              </span>
            )}
          </Col>
          <Col sm={3}>
            {budget && (
              <ApplyBudgetDiscountButton budget={budget} entries={entries} />
            )}
          </Col>
        </Row>
      </div>
      {entries.map(entry => (
        <BookingEntryLine
          entry={entry}
          key={entry.id}
          showSelectBox={showSelectBox}
          onIsSelected={onIsSelected}
          isEditing={isEditing}
          {...rest}
        />
      ))}
    </>
  );
}

BookingEntriesGroup.propTypes = {
  title: string.isRequired,
  entries: arrayOf(bookingEntryShape.isRequired).isRequired,
  budget: number,
  showSelectBox: bool.isRequired,
  onIsSelected: func.isRequired,
  onToggleSelectionMultiple: func.isRequired,
  isEditing: bool,
};

BookingEntriesGroup.defaultProps = {
  budget: undefined,
  isEditing: true,
};

export default BookingEntriesGroup;
